import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import { Map } from "./map";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import HeaderComponent from "../../../../HeaderComponent";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Routes {
  data: {
    routes: {
      color: string;
      id: number;
      position: {
        latitude: number;
        longitude: number;
      };
      status: string;
      status_route_id: number;
    }[];
    count: number;
  };
}

export const MapRoutes = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { id, shortToken , mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);
  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    routes: [
      {
        id: 0,
        color: "",
        position: { latitude: 0, longitude: 0 },
        status: "",
        status_route_id: 0,
      },
    ],
    count: 0,
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/routes/map?graphic_id=mapRoutes&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/routes/map?graphic_id=mapRoutes&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    {
      mode === "view"
        ? setInterval(() => {
            requisition();
          }, 60000)
        : "";
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: Routes) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="map-routes">
      <HeaderComponent title={"Mapa de rotas"} id="map-routes"/>
      <div id="mapa" style={{ borderRadius: "30px !important" }}>
        <div
          className="py-3"
          style={{ borderRadius: "30px !important" }}
        >
          <Map routes={routes} />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
